import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEqual from 'lodash.isequal';
import { Icon } from 'ui';
import { isToggleEnabled } from 'react-awesome-feature-toggles/dist/feature-toggles';
import { laneConfig, blockConfig } from '../../../config';
import TechnicianSkills from './technichian-skills';

const StyledLaneInfo = styled.div`
  min-height: ${p =>
    // eslint-disable-next-line
    (p.totalLines || 1) * blockConfig.height + laneConfig.minHeight}px;
  border-bottom: 1px solid #bac8d5;
  background-color: #fff;
  font-size: 19px;
  padding: 5px 10px;
  overflow: hidden;
`;

const TechnichianName = styled.div`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const StyledIcon = styled(Icon)`
  font-size: 15px;
  cursor: pointer;
`;

/**
 *
 * @param {data} object - data to rendered
 */
const LaneInfo = ({ data, isOpen, setIsPopoverOpen }) => {
  const { totalLines } = data;
  return <StyledLaneInfo totalLines={totalLines} id={data.id}>
    <TechnichianName
      onClick={() =>
        window.open(
          `${window.location.origin}/technician/${data?.id}`, '_blank',
        )}
    >
      {data.description} <StyledIcon className='fa-solid fa-arrow-up-right-from-square' />
    </TechnichianName>
    {isToggleEnabled('skills') && data?.assignedSkills?.length > 0 &&
      <TechnicianSkills
        assignedSkills={data.assignedSkills}
        isOpen={isOpen}
        setIsPopoverOpen={setIsPopoverOpen}
        laneId={data.id}
      />}
  </StyledLaneInfo>;
};

LaneInfo.propTypes = {
  data: PropTypes.object,
  isOpen: PropTypes.bool,
  setIsPopoverOpen: PropTypes.func,
};

const areEqual = (prevProps, nextProps) => {
  if (
    prevProps.data.totalLines === nextProps.data.totalLines &&
    prevProps.data.description === nextProps.data.description &&
    isEqual(prevProps.data.assignedSkills, nextProps.data.assignedSkills) &&
    prevProps.isOpen === nextProps.isOpen
  ) {
    return true;
  }
  return false;
};

export default React.memo(LaneInfo, areEqual);
